import React, { FC } from 'react';
import { Table } from 'antd';
import TableAccountField from './TableAccountField';
import { ColumnsType } from 'antd/lib/table';
import { useTranslation } from 'react-i18next';
import { Location, Terminal } from '~/types';
import { usePath, usePermissions } from '~/hooks';
import { usePageShow } from '~/hooks/usePageQuery';
import { terminals } from '~/routes';
import { Longdash, statusCell } from '~/utils';

interface Props {
  data: Terminal[] | undefined;
  total: number;
  loading: boolean;
  locationsById: Record<string, Location> | undefined;
  accountMap?: Map<string, { id: string; number?: string }>;
  accountsDataLoading?: boolean;
}

const TerminalsTable: FC<Props> = (props) => {
  const { data, total, loading, locationsById = {}, accountMap, accountsDataLoading } = props;
  const { pagination } = usePath();
  const { showOpen } = usePageShow(terminals);
  const [t] = useTranslation('terminals');

  const columns: ColumnsType<Terminal> = [
    statusCell(),
    {
      title: t('label'),
      dataIndex: 'label',
    },
    {
      title: t('type'),
      dataIndex: 'terminalType',
      render: (_, record) => {
        return record?.terminalType ? t(record?.terminalType) : record?.terminalType;
      },
    },

    {
      title: t('linkedAccounts'),
      dataIndex: 'accountIds',
      render: (_, record) => (
        <TableAccountField
          accountIds={record?.accountIds}
          accountMap={accountMap}
          loading={accountsDataLoading}
        />
      ),
    },
    {
      title: t('location'),
      dataIndex: 'locationId',
      render: (_, record) => {
        const id = record.locationId;
        if (!id) return <div>{Longdash}</div>;
        return <div>{locationsById[id]?.name || Longdash}</div>;
      },
    },
    {
      title: t('linkedPhone'),
      dataIndex: 'linkedPhone',
      render: (_, record) => {
        const phone = record.linkedPhone;
        if (!phone) return <div>{Longdash}</div>;
        return (
          <div>
            <bdi>{phone}</bdi>
          </div>
        );
      },
    },
    {
      title: t('device'),
      dataIndex: ['device', 'deviceLabel'],
    },
  ];
  const hasAccessView = usePermissions('business.terminal.view');

  return (
    <Table
      className="TerminalsTable"
      columns={columns}
      dataSource={data}
      loading={loading}
      rowKey={(record) => record.id as string}
      rowClassName="cursor-pointer"
      pagination={{ ...pagination, total }}
      onRow={(record) => ({
        onClick: () => hasAccessView && showOpen(record.id as string),
      })}
    />
  );
};

export default TerminalsTable;
